@if (isLocked) {
  <lib-vitu-tooltip text="Locked">
    <i class="fas fa-lock global-table-cell-image-only user-status-locked"></i>
  </lib-vitu-tooltip>
}
@if (!isLocked) {
  <lib-vitu-tooltip text="Unlocked">
    <i class="far fa-lock-open global-table-cell-image-only user-status-unlocked"></i>
  </lib-vitu-tooltip>
}
